import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "badge bg-warning text-dark d-flex align-items-center lh-1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1" }, "timer", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _hoisted_2,
    _createTextVNode(" " + _toDisplayString(_ctx.$t('userMode')) + " · " + _toDisplayString(_ctx.$t('userModeRemaining', {time: _ctx.remainingTime})), 1)
  ]))
}